import React from 'react'
import { GetServerSideProps } from 'next'

import { API } from '../../../revelry_api'
import FourOFour from '../../../components/pages/FourOFour'
import { FuneralHome, LifePageNavItem, ObituarySnippet } from '../../../types'
import { FuneralHomeFooter } from '../../../components/FuneralHomeFooter'
import LifePageLayout from '../../../components/LifePageLayout'
import Obituary from '../../../components/models/Obituary'
import ObituaryMeta from '../../../components/ObituaryMeta'
import ObituaryPage from '../../../components/pages/ObituaryPage'
import { routes } from '../../../routes'

interface Props {
  funeralHome: FuneralHome | null
  obituary: ObituarySnippet | null
}

const ObituaryPageWrapper: React.FC<Props> = ({ funeralHome, obituary }) => {
  if (!obituary) {
    return <FourOFour />
  }

  const pageTitle = `${Obituary.deceasedFullName(obituary)} Obituary - ${funeralHome?.name}`
  const pageDescription = `See obituary for ${Obituary.deceasedFullName(
    obituary,
  )}. View funeral service information, send condolences or flowers, and upload memories and photos.`
  const DEFAULT_OG_DESCRIPTION =
    'No obituary has been added at this time. Leave a memory or condolence for the family on the "Memories" page.'

  return (
    <>
      <ObituaryMeta
        obituary={obituary}
        funeralHome={funeralHome}
        pageTitle={pageTitle}
        pageDescription={pageDescription}
        canonicalPath={routes.obituary(obituary)}
        ogDescription={obituary.deceased.obituary_text || DEFAULT_OG_DESCRIPTION}
      />

      <LifePageLayout activeNavItem={LifePageNavItem.OBITUARY} obituary={obituary}>
        <ObituaryPage obituary={obituary} />
      </LifePageLayout>

      <FuneralHomeFooter />
    </>
  )
}

export const getServerSideProps: GetServerSideProps = async (req) => {
  try {
    const slugArray = (req.params.slug as string).split('-')
    const obituaryID = slugArray[slugArray.length - 1]
    const [obituary, funeralHome] = await Promise.all([
      API.obituaries.load(obituaryID),
      API.funeralHomes.load(),
    ])

    return { props: { obituary, funeralHome } }
  } catch (e) {
    return { props: { obituary: null, funeralHome: null } }
  }
}

export default ObituaryPageWrapper
